<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Pricelist Website</h5>
            <div class="tabel-action mb-4">
                <button type="button" v-b-modal.modal-Pricelist class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Pricelist</button>
            </div>

            <draggable
                v-bind="dragOptions"
                v-model="pricelist"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in pricelist" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                </div>
                                <div class="link-switch d-flex align-items-center">
                                    <a href="#" v-b-modal.modal-Pricelist v-on:click.prevent="ASSIGN_FORM_PRICELIST(data)" class="act mb-0">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id,index)" class="act mb-0">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Pricelist" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_PRICELIST">

            <ValidationObserver ref="form">
                <div class="row">

                    <div class="col-md-12">
                        <div class="d-flex">
                            <label class="pl-0 custom-switch switch-big">
                                <input v-model="formpricelist.is_spesial" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                <span class="custom-switch-indicator"></span>
                            </label>
                            <label class="mt-3 ml-3">
                                <span class="custom-switch-description ml-0"><strong>Mark Price</strong></span>
                                <p class="desc">This function is used to mark price on website</p>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Name</label>
                                <input v-model="formpricelist.name" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Label</label>
                                <input v-model="formpricelist.label" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="required|numeric" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Price</label>
                                <input v-model="formpricelist.price" type="number" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="required|numeric" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Price Discount</label>
                                <input v-model="formpricelist.price_discount" type="number" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="url" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Link Booking</label>
                                <input v-model="formpricelist.link_book" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                                <small>if you leave this column blank it will automatically lead to whatsapp</small>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="url" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Link Tema</label>
                                <input v-model="formpricelist.link_tema" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                                <small>if you leave this column blank it will automatically lead to tema section on website</small>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Price Include</label>
                            <textarea class="form-control" v-model="formpricelist.include"></textarea>
                            <small>Separate include with commas(,) if you want to load more than one list</small>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Price Exclude</label>
                            <textarea class="form-control" v-model="formpricelist.exclude"></textarea>
                            <small>Separate exclude with commas(,) if you want to load more than one list</small>
                        </div>
                    </div>

                </div>

                <div class="text-right mt-4">
                    <button v-on:click="validationForm(formpricelist.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Pricelist
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                modal_title : 'Add Pricelist',
            }
        },
        watch:{
            'formpricelist':function(val){
                if(val.id){
                    this.modal_title = 'Edit Pricelist'
                }else if(!val.id){
                    this.modal_title = "Add Pricelist"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('WebsiteControl', {
                website: state => state.website,
                formpricelist: state => state.formpricelist
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            pricelist: {
                get() {
                    return this.website.pricelist
                },
                set(value) {
                    this.SET_POSITION_PRICELIST(value)
                    this.updatePositionPricelist(value)
                }
            }
        },
        methods:{
            ...mapMutations('WebsiteControl', ['SET_POSITION_PRICELIST','CLEAR_FORM_PRICELIST','ASSIGN_FORM_PRICELIST']),
            ...mapActions('WebsiteControl', ['getWebsite','createPricelist','updatePricelist','deletePricelist','updatePositionPricelist']),

            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        if(id){

                            this.updatePricelist(this.formpricelist).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Pricelist')
                                this.getWebsite(this.$route.params.id)
                                this.$toast.success('Successfully Update Pricelist')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createPricelist(this.formpricelist).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Pricelist')
                                this.getWebsite(this.$route.params.id)
                                this.$toast.success('Successfully Added Pricelist')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
            alertDelete:function(id,index){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this pricelist data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deletePricelist(id).then(
                            this.$toast.success('Successfully Deleting Pricelist'),
                            this.website.pricelist.splice(index, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>

<style scoped>
    .img-sh img{
        width: 300px;
    }
    .link-icon img,
    .link-icon .no-img{
        width: 60px;
        height: 60px;
    }
    .btn-outline-secondary.qr{
        width: 100px;
        height: 100px;
    }
    .category-themes .btn-outline-secondary.qr:nth-child(3) img{
        width: 45px !important;
    }
    .btn-outline-secondary{
        border-color: #e4e6fc;
    }
    .btn-outline-secondary.active,
    .btn-outline-secondary:hover {
        background: #e4e6fc !important;
        border-color: #e4e6fc !important;
    }

</style>
